// Global reset + tokens first, so every section stylesheet can override it.
import "../styles/base.css";
import { useRef } from "react";
import Sidebar from "../components/Sidebar";
import HeroSection from "../components/HeroSection";
import SkillsSection from "../components/SkillsSection";
import ProjectsSection from "../components/ProjectSection";
import BlogSection from "../components/BlogSection";
import Footer from "../components/Footer";
import useScrollReveal from "../hooks/useScrollReveal";
import "../styles/layout.css";
import "../styles/reveal.css";

// This is your public portfolio homepage — exactly what it was before, just
// moved into its own page component so the router can show it at "/".
const Home = () => {
  const mainContentRef = useRef(null);
  useScrollReveal();

  return (
    <div className="layout-container">
      <Sidebar mainContentRef={mainContentRef} />
      <main className="main-content" ref={mainContentRef}>
        <HeroSection />
        <SkillsSection />
        <ProjectsSection />
        <BlogSection />
        <Footer />
      </main>
    </div>
  );
};

export default Home;
